import { render, staticRenderFns } from "./compensation-modal.vue?vue&type=template&id=f5ca57e0&scoped=true&"
import script from "./compensation-modal.vue?vue&type=script&lang=js&"
export * from "./compensation-modal.vue?vue&type=script&lang=js&"
import style0 from "./compensation-modal.vue?vue&type=style&index=0&id=f5ca57e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ca57e0",
  null
  
)

export default component.exports